export default {"src":"/_next/static/media/insurance.84fdb729.svg","height":47,"width":45,"blurWidth":0,"blurHeight":0};